import { LocalStorage } from '@/shared/lib/utils/localStorage.ts'

export class AgreementStorage {
  private static _key = '__lair_terms_conditions__'

  public static get() {
    return Boolean(LocalStorage.get(this._key))
  }

  public static set(value: boolean) {
    LocalStorage.set(this._key, value ? 'true' : 'false')
  }

  public static remove() {
    LocalStorage.remove(this._key)
  }
}
